export enum StylePriority {
  Emmet,
  Platform
}
